import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, offer, pricingRows } from '../data/content';
export function Pricing() {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-107" data-mp="2ar2ea9wnokl1">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-108" data-mp="2ohnxjzq0uwjg">
        <h2 className="mx-auto max-w-xl text-center text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-109" data-mp="2jjw616tahcfs">
          Oferta especial de lanzamiento
        </h2>

        <div className="relative mx-auto mt-14 max-w-xl rounded-3xl bg-white px-6 pb-8 pt-10 ring-2 ring-blue-600 md:px-10 md:pb-10" data-id="element-110" data-mp="1rsgagn9r8fdf">
          <p className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-blue-600 px-5 py-1.5 text-xs font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-111" data-mp="25shl2uftn163">
            Sistema completo
          </p>

          <dl className="divide-y divide-blue-100" data-id="element-112" data-mp="3h9he5s9ztk16">
            {pricingRows.map(row => <div key={row.label} className="flex items-start justify-between gap-6 py-4" data-id="element-113" data-mp="3c81ofmwvepcg">
                <dt className="text-slate-900" data-id="element-114" data-mp="3vz71w0ckytr2">{row.label}</dt>
                <dd className="shrink-0 font-extrabold text-blue-700" data-id="element-115" data-mp="4scnl0sv7ss1">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-6 py-4" data-id="element-116" data-mp="9tjuyyr3ipy6">
              <dt className="text-sm font-extrabold uppercase tracking-[0.14em] text-slate-900" data-id="element-117" data-mp="erlfzp830zca">
                Valor total:
              </dt>
              <dd className="shrink-0 font-extrabold text-slate-500 line-through" data-id="element-118" data-mp="3d6up0joawa2o">
                {offer.totalValue}
              </dd>
            </div>
          </dl>

          <div className="mt-6 text-center" data-id="element-119" data-mp="3n6d70uknhls3">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-blue-600" data-id="element-120" data-mp="3n5ag4mnbvjc6">
              Sólo hoy
            </p>
            <p className="mt-2 text-7xl font-extrabold leading-none tracking-tight text-blue-600 md:text-8xl" data-id="element-121" data-mp="2uj99tbrsubqv">
              {offer.price}
            </p>
          </div>

          <div className="mt-8 border-t border-blue-100 pt-7" data-id="element-122" data-mp="2rgv1tjl906gd">
            <div data-id="element-123" data-mp="2rfa6hrr40jhg">
              <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-124" data-mp="2rerzq16tmmva">
                {offer.cta}
              </CtaButton>
            </div>
            <p className="mt-4 text-center text-sm text-slate-500" data-id="element-125" data-mp="316xqx8p9109f">
              Descarga instantánea · Pago único · Acceso de por vida · Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}